(() => {
  const summarySelector = '.desktop-mega__more > summary';

  const expandMoreLinks = (event) => {
    const summary = event.target.closest(summarySelector);
    if (!summary) return;

    if (event.type === 'click') {
      event.preventDefault();
    }

    summary.parentElement.open = true;
  };

  document.addEventListener('mouseover', expandMoreLinks);
  document.addEventListener('focusin', expandMoreLinks);
  document.addEventListener('click', expandMoreLinks);
})();
